import {DOMAttrs, m, View} from '@codeurs/front'

export class AutoHide extends View<{as?: any} & DOMAttrs> {
	lastScroll = 0
	offset = 0

	onCreate(dom: HTMLElement) {
		const {style} = dom
		style.position = 'fixed'
		const height = dom.offsetHeight + 10
		const scroll = () => {
			const y = window.pageYOffset
			if (y < 0) return
			const diff = this.lastScroll - y
			this.offset += diff
			if (this.offset < -height) this.offset = -height
			if (this.offset >= 0) this.offset = 0
			style.transform = `translateY(${this.offset}px)`
			style.transition = 'none'
			this.lastScroll = y
		}
		window.addEventListener('scroll', scroll)
		this.onRemove = () => window.removeEventListener('scroll', scroll)
	}
	render() {
		const {children, as: tag = 'div', ...attrs} = this.attrs
		return m(tag, attrs, children)
	}
}
